import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ca5b980"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "fullscreen-modal__top-title" }
const _hoisted_4 = { class: "fullscreen-modal__title" }
const _hoisted_5 = { class: "summary-item__col summary-item__col--pricegroup" }
const _hoisted_6 = { class: "summery-item__col-label" }
const _hoisted_7 = { class: "summery-item__col-value" }
const _hoisted_8 = {
  key: 0,
  class: "summary-item__col summary-item__col--option"
}
const _hoisted_9 = { class: "summery-item__col-label" }
const _hoisted_10 = { class: "summery-item__col-value" }
const _hoisted_11 = { class: "summery-item__col-value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-item__separator" }, "|", -1))
const _hoisted_13 = {
  key: 1,
  class: "summary-item__col summary-item__col--insurance"
}
const _hoisted_14 = { class: "summery-item__col-label" }
const _hoisted_15 = { class: "summery-item__col-value" }
const _hoisted_16 = { class: "summary-item__col summary-item__col--price" }
const _hoisted_17 = { class: "summery-item__col-label" }
const _hoisted_18 = { class: "summery-item__col-value" }
const _hoisted_19 = {
  key: 0,
  class: "text-price-before text-no-break"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn-popover btn-popover bg-success" }, "%", -1))
const _hoisted_21 = { class: "summary-item__col d-flex justify-content-end summary-item__col--actions" }
const _hoisted_22 = { class: "summary-item__btn-wrapper" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-edit",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_25 = { class: "d-none d-md-inline-flex" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-delete",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_28 = { class: "d-none d-md-inline-flex" }
const _hoisted_29 = { class: "row mb-3" }
const _hoisted_30 = { class: "col-md-8" }
const _hoisted_31 = { class: "ticket-configuration__small-title" }
const _hoisted_32 = { class: "col-md-4 text-end" }
const _hoisted_33 = { class: "mt-5 d-flex justify-content-end gap-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-checkmark text-success",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_TicketConfigurations = _resolveComponent("TicketConfigurations")!
  const _component_EditModal = _resolveComponent("EditModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('shop.configuration.verify-tickets')), 1),
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.title), 1),
        (!_ctx.isPriceCalculator)
          ? (_openBlock(), _createBlock(_component_Breadcrumb, {
              key: 0,
              step: _ctx.step,
              onChangeStep: _ctx.onChangeStep,
              stepViews: _ctx.stepViews
            }, null, 8, ["step", "onChangeStep", "stepViews"]))
          : (_openBlock(), _createBlock(_component_Breadcrumb, {
              key: 1,
              step: _ctx.step,
              onChangeStep: _ctx.onChangeStep,
              stepViews: _ctx.stepViews,
              type: 'pricecalculator'
            }, null, 8, ["step", "onChangeStep", "stepViews"]))
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_TransitionGroup, {
        name: "list",
        tag: "ul",
        class: "list-unstyled summary-item-list"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketConfigurations.configurations, (item, key) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["summary-item", _ctx.hasServiceView ? 'summary-item--big' : '']),
              key: 'summary-' + item.id
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.personId ? _ctx.getPriceGroupItem(item.priceGroup).label : _ctx.translate('Shop.configuration.age-group')), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.personId ? _ctx.getPersonItem(item.personId).name : _ctx.getPriceGroupItem(item.priceGroup).label), 1)
              ]),
              (_ctx.hasServiceView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.translate('shop.configuration.configure-ticket')), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_ctx.getOptionItem(item.option)?.label) + " ", 1),
                      (item.upgrades.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getUpgradeItems(item.upgrades), (item) => {
                            return (_openBlock(), _createElementBlock("span", _hoisted_11, [
                              _hoisted_12,
                              _createTextVNode(" " + _toDisplayString(item?.label), 1)
                            ]))
                          }), 256))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasServiceView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.translate('Shop.configuration.insurance')), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.getInsuranceItem(item.insurance)?.label ? _ctx.getInsuranceItem(item.insurance).label : _ctx.translate('shop.ticket.No-insurance')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.translate('shop.configuration.price')), 1),
                _createElementVNode("div", _hoisted_18, [
                  (item.price.priceBeforeDiscount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.convertInCurrency(item.price.priceBeforeDiscount, _ctx.selectedCurrency)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["font-default-bold text-no-break", item.price.priceBeforeDiscount ? 'd-block' : ''])
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.convertInCurrency(item.price.price, _ctx.selectedCurrency)) + " ", 1),
                    (item.price.priceDiscountInfo)
                      ? (_openBlock(), _createBlock(_component_Popper, { key: 0 }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(item.price.priceDiscountInfo), 1)
                          ]),
                          default: _withCtx(() => [
                            _hoisted_20
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.hasServiceView)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-lightgrey btn-sm d-flex gap-1 summary-item__action-btn",
                        onClick: ($event: any) => (_ctx.editConfiguration(item.id))
                      }, [
                        _hoisted_24,
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.translate('shop.configuration.edit-person')), 1)
                      ], 8, _hoisted_23))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-lightgrey btn-sm d-flex gap-1 summary-item__action-btn",
                    onClick: ($event: any) => (_ctx.deleteConfiguration(item.id))
                  }, [
                    _hoisted_27,
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.translate('shop.configuration.delete-person')), 1)
                  ], 8, _hoisted_26)
                ])
              ])
            ], 2))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_EditModal, {
        show: _ctx.showEditModal,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeAndResetEditModal()))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.translate('shop.configuration.change-ticket-configuration-for')) + ": " + _toDisplayString(_ctx.getPersonItem(_ctx.editConfigurationItem.personId) ? _ctx.getPersonItem(_ctx.editConfigurationItem.personId).name : _ctx.getPriceGroupItem(_ctx.editConfigurationItem.priceGroup).label), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createTextVNode(_toDisplayString(_ctx.translate('shop.configuration.price')) + ": ", 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.priceString), 1)
            ])
          ]),
          _createVNode(_component_TicketConfigurations, {
            type: "edit",
            hideTexts: true,
            ticketId: _ctx.ticketId,
            selectedDateStart: _ctx.editConfigurationItem.dateStart,
            selectedDateEnd: _ctx.editConfigurationItem.dateEnd,
            selectedOption: _ctx.editConfigurationItem.option,
            onChangeOption: _ctx.onChangeOption,
            selectedInsurance: _ctx.editConfigurationItem.insurance,
            onChangeInsurance: _ctx.onChangeInsurance,
            selectedUpgrades: _ctx.editConfigurationItem.upgrades,
            onChangeUpgrades: _ctx.onChangeUpgrades,
            selectedPriceConfiguration: _ctx.editPriceConfiguration,
            selectedCurrency: _ctx.selectedCurrency,
            selectedPriceGroup: _ctx.editConfigurationItem.priceGroup,
            ticketConfigurations: _ctx.editTempConfiguration,
            onChangePrice: _ctx.onChangePrice,
            onChangePriceConfiguration: _ctx.onChangePriceConfiguration
          }, null, 8, ["ticketId", "selectedDateStart", "selectedDateEnd", "selectedOption", "onChangeOption", "selectedInsurance", "onChangeInsurance", "selectedUpgrades", "onChangeUpgrades", "selectedPriceConfiguration", "selectedCurrency", "selectedPriceGroup", "ticketConfigurations", "onChangePrice", "onChangePriceConfiguration"]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", {
              class: "btn btn-outline-dark btn-block btn-lg summary-item-list__btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeAndResetEditModal()))
            }, [
              _hoisted_34,
              _createTextVNode(" " + _toDisplayString(_ctx.translate('shop.configuration.cancel')), 1)
            ]),
            _createElementVNode("button", {
              class: "btn btn-dark btn-block btn-lg summary-item-list__btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveConfiguration(_ctx.editConfigurationItem)))
            }, [
              _hoisted_35,
              _createTextVNode(" " + _toDisplayString(_ctx.translate('shop.configuration.save')), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}